<div class="container">
    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title matTooltip="Aktionen, die Kunden zur Verfügung stehen"
                    [matTooltipPosition]="'above'">Aktive Aktionen:</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h2 *ngIf="eventCount$  | async as eventCount; else loading">{{ eventCount}}</h2>
                    <ng-template #loading>
                        <mat-spinner [diameter]="35"></mat-spinner>
                    </ng-template>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                        [matTooltipPosition]="'above'">Alle Aktionen:</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h2 *ngIf="alleventCount$  | async as alleventCount; else loading">{{ alleventCount}}</h2>
                    <ng-template #loading>
                        <mat-spinner [diameter]="35"></mat-spinner>
                    </ng-template>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title matTooltip="Partner, die Aktionen zur Verfügung stellen"
                    [matTooltipPosition]="'above'">Partner:</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h2 *ngIf="partnerCount$  | async as partnerCount; else loading">{{ partnerCount}}</h2>
                    <ng-template #loading>
                        <mat-spinner [diameter]="35"></mat-spinner>
                    </ng-template>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Aktionstypen</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <span class="example-list-section">
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_donut_types.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span>
                </mat-card-header>
                <mat-card-content style="min-height:250px;">
                    <ibm-donut-chart [data]="data_donut_types" [options]="config_donut_types"
                        *ngIf="this.hasEventV1 && this.data_donut_types.length != 0  && finishedLoadingTypes">
                    </ibm-donut-chart>
                    <div *ngIf="this.data_donut_types.length == 0  && finishedLoadingTypes" class="pieChartEmptyState">
                        Keine Daten
                    </div>
                    <div *ngIf="!finishedLoadingTypes" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Aktioneinschränkungen</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <span class="example-list-section">
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_donut_eventLimits.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span>
                </mat-card-header>
                <mat-card-content style="min-height:250px;">
                    <ibm-donut-chart [data]="data_donut_eventLimits" [options]="config_donut_types"
                        *ngIf="this.hasEventV1 && this.data_donut_eventLimits.length != 0  && finishedLoadingTypes">
                    </ibm-donut-chart>
                    <div *ngIf="this.data_donut_eventLimits.length == 0  && finishedLoadingTypes"
                        class="pieChartEmptyState">
                        Keine Daten
                    </div>
                    <div *ngIf="!finishedLoadingTypes" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Aktionsgutscheincodes</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <span class="example-list-section">
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_donut_voucherStrats.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span>
                </mat-card-header>
                <mat-card-content style="min-height:250px;">
                    <ibm-donut-chart [data]="data_donut_voucherStrats" [options]="config_donut_types"
                        *ngIf="this.hasEventV1 && this.data_donut_voucherStrats.length != 0 && finishedLoadingTypes">
                    </ibm-donut-chart>
                    <div *ngIf="this.data_donut_voucherStrats.length == 0 && finishedLoadingTypes"
                        class="pieChartEmptyState">
                        Keine Daten
                    </div>
                    <div *ngIf="!finishedLoadingTypes" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row" [formGroup]="fiterForm">
        <div class="col-lg-4">
            <mat-form-field class="full-width">
                <mat-label>Zeitraum auswählen</mat-label>
                <mat-select formControlName="dropDownTime" (selectionChange)="timeChangedByDropDown($event)"
                    [disabled]="(!finishedLoadingLineChartUserCount && !finishedLoadingFlopsAndTops && !finishedLoadingComparison && !finishedLoadingTypes && !finishedLoadingLineChartUserCount && !finishedLoadingTree) || pdfIsGenerating">
                    <mat-option *ngFor="let sortOption of sortOptions" [value]="sortOption.value"
                        [disabled]="sortOption.state">
                        {{sortOption.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-lg-1">
        </div>
        <div class="col-lg-7">
            <mat-form-field appearance="fill" class="full-width" appearance="standard">
                <mat-label>Eigenen Zeitraum eingeben:</mat-label>
                <mat-date-range-input [rangePicker]="picker" [max]="maxDate"
                    [disabled]="(!finishedLoadingLineChartUserCount && !finishedLoadingFlopsAndTops && !finishedLoadingComparison && !finishedLoadingTypes && !finishedLoadingLineChartUserCount && !finishedLoadingTree)  || pdfIsGenerating">
                    <input matStartDate readOnly placeholder="Start" formControlName="startDate"
                        (dateChange)="timeChangedByDateRange($event)">
                    <input matEndDate readOnly placeholder="Ende" formControlName="endDate"
                        (dateChange)="timeChangedByDateRange($event)">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <mat-error *ngIf="differenceIsLessThan61">
                Die Differenz muss mindestens 60 Tage betragen
            </mat-error>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-6 marginBottom2Rem">
            <button mat-raised-button color="accent"
                [disabled]="(!finishedLoadingLineChartUserCount && !finishedLoadingFlopsAndTops && !finishedLoadingComparison && !finishedLoadingTypes && !finishedLoadingLineChartUserCount && !finishedLoadingTree)  || !finishedLoadingLineChartUserCount " (click)="generatePDF()"> PDF
                generieren
                <mat-icon *ngIf="pdfIsGenerating">
                    <mat-spinner color="primary" diameter="20">
                    </mat-spinner>
                </mat-icon>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>
                            Nutzerzahlen seit dem {{startDate | date: 'dd.MM.yyyy'}}
                        </mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="!finishedLoadingLineChartUserCount" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ibm-line-chart #userCount id="canvas" [data]="data_usercount" [options]="options_line">
                    </ibm-line-chart>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title>
                        Ersparnise seit dem {{startDate | date: 'dd.MM.yyyy'}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="!finishedLoadingLineChartUserCount" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ibm-line-chart [data]="data_saving" [options]="options_line"></ibm-line-chart>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title>
                        Kategorienverteilung
                    </mat-card-title>
                    <div fxFlex></div>
                    <span class="example-list-section">
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_interest.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span>
                </mat-card-header>
                <mat-card-content>
                    <ibm-simple-bar-chart [data]="data_interest" [options]="options_line_simple"
                        *ngIf="data_interest.length > 0"></ibm-simple-bar-chart>
                    <div *ngIf="data_interest.length == 0" class="pieChartEmptyState">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>



    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Aktionen nach Partnern</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <span class="example-list-section">
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_partners.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span>
                </mat-card-header>
                <mat-card-content>
                    <ibm-simple-bar-chart [data]="data_partners" [options]="options_line_partners"
                        *ngIf="data_partners.length >0"></ibm-simple-bar-chart>
                    <div *ngIf="data_partners.length == 0" class="pieChartEmptyState">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Preisnachlass</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <span class="example-list-section">
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_savings.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span>
                </mat-card-header>
                <mat-card-content>
                    <ibm-simple-bar-chart [data]="data_savings" [options]="options_line_savings"
                        *ngIf="data_savings.length > 0"></ibm-simple-bar-chart>
                    <div *ngIf="data_savings.length == 0" class="pieChartEmptyState">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>



    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title>
                        Aktionen nach Partnern
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content style="min-height:250px;">
                    <ibm-tree-chart [options]="this.tree_options" [data]="this.treeData"
                        *ngIf="this.finishedLoadingTree">
                    </ibm-tree-chart>
                    <div *ngIf="!this.finishedLoadingTree" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<div class="container" *ngIf="notEnoughEvents">
    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Nicht genügend Daten
                    </mat-card-title>
                    <mat-card-subtitle>
                        Um das Reporting nutzen zu können, müssen Sie mindestens eine aktive Aktion einstellen.
                    </mat-card-subtitle>
                </mat-card-header>
            </mat-card>
        </div>
    </div>
</div>